import React from 'react';

import { SystemState } from './SystemState';
import { resolveSystemStatus } from './systemStateStatus';


/**
 * Status-aware full-page error fallback for the router / CatchBoundary
 * `errorComponent` (AUTOORBIT-419).
 *
 * Receives `{ error, reset }` from TanStack Router, maps the error's HTTP
 * status to a 403 / 404 / 500 system state via `resolveSystemStatus`, and
 * renders the matching `SystemState`. The raw `error` is threaded through so
 * the 500 state can pick connection-flavored copy for no-response failures, and
 * `reset` backs the 500 "Reload page" action.
 */
const ErrorBoundaryState = React.forwardRef((props, ref) => {
  const { error = null, reset = null, ...restProps } = props;
  const status = resolveSystemStatus(error);

  return <SystemState ref={ref} reset={reset} status={status} error={error} {...restProps} />;
});

ErrorBoundaryState.displayName = 'ErrorBoundaryState';

export { ErrorBoundaryState };
export default ErrorBoundaryState;
